import { generateRepositoryMethods, } from '../webapp/repository.types.js';
export const promotionRepositoryMethods = generateRepositoryMethods({
    getAllPromotions: {
        callMethod: 'GET',
        endpoint: '/promotions/all',
    },
    getPromotionsById: {
        callMethod: 'GET',
        endpoint: '/promotions/by-id',
    },
    updatePromotion: {
        callMethod: 'PUT',
        endpoint: '/promotions/update',
    },
    createPromotion: {
        callMethod: 'POST',
        endpoint: '/promotions/create',
    },
    exportPromotionsAsCsv: {
        callMethod: 'GET',
        endpoint: '/promotions/export/csv',
    },
    setPromotionsLastRunning: {
        callMethod: 'PUT',
        endpoint: '/promotions/set-last-running',
    },
});
//# sourceMappingURL=promotion.methods.js.map